enum Layout {
    Bubble,
    Card
}

export default Layout;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/definitions/Layout.ts
 **/